import script from "./InvestCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./InvestCard.vue?vue&type=script&setup=true&lang=ts"

import "./InvestCard.vue?vue&type=style&index=0&id=9decc050&scoped=true&lang=postcss"

import exportComponent from "/var/www/rentasdhelos.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9decc050"]])

export default __exports__